// removed by extract-text-webpack-plugin
module.exports = {"descriptionList":"antd-pro-description-list-descriptionList","title":"antd-pro-description-list-title","term":"antd-pro-description-list-term","detail":"antd-pro-description-list-detail","vertical":"antd-pro-description-list-vertical","descriptionListSmall":"antd-pro-description-list-descriptionListSmall","descriptionListLarge":"antd-pro-description-list-descriptionListLarge"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/DescriptionList/index.less
// module id = 235
// module chunks = 0